import WorkflowCrumb from '../components/WorkflowCrumb';
import WorkflowsFolderCrumb from '../components/WorkflowsFolderCrumb';
import VersionCrumb from '../components/VersionCrumb';
import StaticCrumb from '../components/StaticCrumb';
import TestCaseCrumb from '../components/TestCaseCrumb';
import { BreadcrumbRouteConfig } from '../types';

export const workflowsRoutes: BreadcrumbRouteConfig = {
    path: '/agents/:agentId/workflows',
    breadcrumbs: [
        {
            component: WorkflowsFolderCrumb,
            props: { param: 'workflowId' },
        },
    ],
    children: [
        {
            path: ':workflowId/versions/:versionId',
            breadcrumbs: [
                {
                    component: WorkflowCrumb,
                    props: { param: 'workflowId' },
                },
                {
                    component: VersionCrumb,
                    props: { param: 'versionId', showBadge: true },
                },
            ],
            children: [
                {
                    path: 'builder',
                    breadcrumbs: [
                        {
                            component: StaticCrumb,
                            props: { label: 'builder', isCurrentPage: true },
                        },
                    ],
                },
                {
                    path: 'history',
                    breadcrumbs: [
                        {
                            component: StaticCrumb,
                            props: { label: 'history', isCurrentPage: true },
                        },
                    ],
                },
                {
                    path: 'testing',
                    breadcrumbs: [
                        {
                            component: StaticCrumb,
                            props: { label: 'testing', isCurrentPage: true },
                        },
                    ],
                },
                {
                    path: 'testing/:testCaseId',
                    breadcrumbs: [
                        {
                            component: StaticCrumb,
                            props: {
                                label: 'testing',
                                href: '/agents/:agentId/workflows/:workflowId/versions/:versionId/testing',
                            },
                        },
                        {
                            component: TestCaseCrumb,
                            props: { param: 'testCaseId' },
                        },
                    ],
                },
                {
                    path: ':mode',
                    breadcrumbs: [
                        {
                            component: StaticCrumb,
                            props: { label: 'playground', isCurrentPage: true },
                        },
                    ],
                },
                {
                    path: ':mode/threads/:threadId',
                    breadcrumbs: [
                        {
                            component: StaticCrumb,
                            props: { label: 'playground', isCurrentPage: true },
                        },
                    ],
                },
            ],
        },
    ],
};
